import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { makeStyles, shorthands } from '@fluentui/react-components';
import {
  Button,
} from '@fluentui/react-components';
import ErrorReportingService from '../common/ErrorReportingService';

const useStyles = makeStyles({
  header: {
    ...shorthands.padding('10px'),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#5c5c5c',
    color: '#fff',
  },
  nav: {
    display: 'flex',
    gap: '10px',
  },
  menuButton: {
    color: '#FFF',
  },
  testButton: {
    backgroundColor: '#d32f2f',
    color: '#fff',
    ...shorthands.border('2px', 'solid', '#b71c1c'),
    '&:hover': {
      backgroundColor: '#b71c1c',
    },
  },
});

const Header: React.FC = () => {
  const styles = useStyles();
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const handleTestError = () => {
    // Get environment info
    const errorReporting = ErrorReportingService.getInstance();
    const envInfo = errorReporting.getEnvironmentInfo();
    
    // Test different types of errors
    const errorType = Math.floor(Math.random() * 4);
    
    switch (errorType) {
      case 0:
        // Test React Error Boundary
        throw new Error(`Test React Error Boundary - This is a simulated crash for testing Slack alerts (${envInfo.environment})`);
      case 1:
        // Test unhandled promise rejection
        Promise.reject(new Error(` Test Promise Rejection - This is a simulated promise rejection for testing Slack alerts (${envInfo.environment})`));
        break;
      case 2:
        // Test custom error reporting
        errorReporting.reportCustomError(`Test Custom Error - This is a manual error report for testing Slack alerts (${envInfo.environment})`, {
          testData: 'Custom error test',
          userId: 'test-user-123',
          environment: envInfo.environment,
          timestamp: new Date().toISOString()
        });
        alert(`Custom error sent to Slack ${envInfo.environment} channel! Check your alerts.`);
        break;
      case 3:
        // Test API error simulation
        errorReporting.reportApiError('/test/endpoint', 500, 'Internal Server Error', {
          testError: true,
          environment: envInfo.environment,
          message: `Simulated API error for testing (${envInfo.environment})`
        });
        alert(`API error sent to Pub/Sub via ${envInfo.environment} API! Check your Pub/Sub topic for the message.`);
        break;
      default:
        throw new Error(`Test Error - Default case (${envInfo.environment})`);
    }
  };

  return (
    <header className={styles.header}>
      <h1>Gestion des Mill Tests</h1>
      <nav className={styles.nav}>
        <Button className={styles.menuButton} onClick={() => handleNavigation('/')} appearance="primary">Accueil</Button>
        <Button className={styles.menuButton} onClick={() => handleNavigation('/upload')} appearance="primary">Importer</Button>
        <Button className={styles.menuButton} onClick={() => handleNavigation('/review')} appearance="primary">Réviser</Button>
        
        {/* Test button - show in development environment */}
        {process.env.REACT_APP_ENVIRONMENT === 'development' && (
          <Button 
            className={styles.testButton} 
            onClick={handleTestError}
            appearance="primary"
            title={`Test Pub/Sub error alerts for ${process.env.REACT_APP_ENVIRONMENT || 'development'} environment`}
          >
            🚨 Test Alert ({process.env.REACT_APP_ENVIRONMENT || 'dev'})
          </Button>
        )}
      </nav>
    </header>
  );
};

export default Header;
